import React, { useMemo } from "react";
import { TransformComponent, TransformWrapper } from "react-zoom-pan-pinch";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogTitle,
  IconButton,
  DialogContent,
  DialogActions,
} from "@mui/material";
import ResetIcon from "@mui/icons-material/Refresh";

import downloadFile from "utils/downloadFile";

const DocumentPreviewModal = ({
  url,
  documentTypeName,
  documentName,
  documentType = "",
  isOpen = false,
  isDownloadable = true,
  handleClose = () => {},
  actionButton = null,
  t,
}) => {
  const isPdf = useMemo(
    () => documentType.toLowerCase() === "pdf",
    [documentType]
  );
  return (
    <>
      <Dialog
        open={isOpen}
        onClose={handleClose}
        maxWidth="lg"
        scroll="paper"
        PaperProps={
          isPdf
            ? {
                sx: {
                  width: "100%",
                  height: "80vh",
                },
              }
            : {}
        }
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
        className="h-100"
        sx={{ overflow: "hidden" }}
      >
        {isPdf ? (
          <>
            <DialogTitle
              className="mb-2 d-flex justify-content-between"
              bgcolor="transparent"
              component="div"
            >
              <h3>{t(`${documentTypeName}`)}</h3>
              <div className="justify-content-end">
                {isDownloadable && !isPdf && (
                  <IconButton
                    className="ri-download-2-line ri-lg"
                    onClick={() =>
                      downloadFile(url, `${documentName}.${documentType}`)
                    }
                  />
                )}
                <IconButton
                  className="ri-close-line ri-lg"
                  aria-label="close"
                  onClick={handleClose}
                />
              </div>
            </DialogTitle>
            <embed
              src={url}
              style={{
                width: "100%",
                height: "100%",
                overflow: "hidden",
              }}
              type="application/pdf"
            />
          </>
        ) : (
          <TransformWrapper
            initialScale={1}
            options={{
              initialScale: 1,
              minScale: 0.5,
              maxScale: 2,
            }}
            centerZoomedOut
            wheel={{
              wheelDisabled: true,
            }}
          >
            {({ zoomIn, zoomOut, resetTransform }) => (
              <>
                <DialogTitle
                  className="mb-2 d-flex justify-content-between"
                  bgcolor="transparent"
                  component="div"
                >
                  <h3>{t(`${documentTypeName}`)}</h3>
                  <div className="justify-content-end">
                    {isDownloadable && !isPdf && (
                      <IconButton
                        className="ri-download-2-line ri-lg"
                        onClick={() =>
                          downloadFile(url, `${documentName}.${documentType}`)
                        }
                      />
                    )}
                    <IconButton
                      onClick={() => zoomIn()}
                      className="ri-zoom-in-line ri-lg"
                    />
                    <IconButton
                      onClick={() => zoomOut()}
                      className="ri-zoom-out-line ri-lg"
                    />
                    <IconButton onClick={() => resetTransform()}>
                      <ResetIcon />
                    </IconButton>
                    <IconButton
                      className="ri-close-line ri-lg"
                      aria-label="close"
                      onClick={handleClose}
                    />
                  </div>
                </DialogTitle>
                <DialogContent className="w-100 h-75">
                  <TransformComponent>
                    <img src={url} className="w-100" id="download-image" />
                  </TransformComponent>
                </DialogContent>
              </>
            )}
          </TransformWrapper>
        )}
        {!!actionButton && (
          <DialogActions style={{ paddingRight: "24px" }}>
            {actionButton}
          </DialogActions>
        )}
      </Dialog>
    </>
  );
};

DocumentPreviewModal.propTypes = {
  url: PropTypes.string,
  documentTypeName: PropTypes.string,
  documentName: PropTypes.string,
  documentType: PropTypes.string,
  isOpen: PropTypes.bool,
  handleClose: PropTypes.func,
  actionButton: PropTypes.oneOfType([PropTypes.element, PropTypes.bool]),
  t: PropTypes.func,
  isDownloadable: PropTypes.bool,
};

export default withTranslation()(DocumentPreviewModal);
